import * as tslib_1 from "tslib";
import * as moment from 'moment';
import { InputDateTimeComponent } from '../input-datetime/input-datetime.component';
import createAutoCorrectedDateTimePipe from '../../pipes/create-datetime.pipe';
import { LocalisationService } from '../../../core/localisation.service';
/**
 * Class for input component for date input
 */
var InputDateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputDateComponent, _super);
    function InputDateComponent(localisationService) {
        var _this = _super.call(this, localisationService) || this;
        _this.allowedStates = ['year', 'month', 'day'];
        _this.placeholderKey = 'APP.INPUTS.DATE_PLACEHOLDER';
        return _this;
    }
    Object.defineProperty(InputDateComponent.prototype, "formatString", {
        get: function () {
            return this.localisationService.date.format;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputDateComponent.prototype, "pipe", {
        get: function () {
            return createAutoCorrectedDateTimePipe(this.localisationService.date.correctionFormat);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputDateComponent.prototype, "mask", {
        get: function () {
            return LocalisationService.toMaskArray(this.localisationService.date.mask);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Safe translate string date to value.
     * Is needed for InputDateComponent when used in different time zones.
     * @protected
     * @param {Moment} translated The value translated from the string.
     */
    InputDateComponent.prototype.safeTranslateFromString = function (translated) {
        var newValue = translated.toDate();
        var oldValue = this.value;
        this.value = moment.isDate(oldValue)
            ? new Date(newValue.getFullYear(), newValue.getMonth(), newValue.getDate(), oldValue.getHours(), oldValue.getMinutes())
            : this.value = translated.toDate();
    };
    return InputDateComponent;
}(InputDateTimeComponent));
export { InputDateComponent };
